import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  CELL_RENDERERS, Table, TABLE_LAYOUT_OPTIONS, Loader, Dialog } from 'cdk-radial';
import './UnsubscribedTable.scss';
import map from 'lodash/map';
import config from '../../../../utils/config'
import ResubscribeSolution from './ResubscribeSolution';
import Overlay from '../../../Overlay/Overlay';
import RadioGroup from '../../../RadioGroup/RadioGroup';
import { getLatestDate, dateComparator, showTooltip, onGridReady } from '../common';
import { clearSolutionInfo, getSolutionInfo } from '../../../../redux/connectedComponent/solutionInfo/solutionInfo.slice';
import { getEntityById } from '../../../../redux/connectedComponent/subscriptionManagement/subscriptionManagement.slice';
import AuthComponent from '../../../common/AuthComponent';
import { modifyStr } from '../../../../utils/utils';
import ShowLocations from '../ShowLocations';
import { AppLink } from '../utils/AppLink';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';

const SUBSCRIPTION = 'Subscription';
const ACTIVATION = 'Activation';
const FORTELLIS_ADMIN = 'Fortellis Admin';

const UnsubscribedTable = ({unsubscribedTableLayout, checkUnsubscribedTablePagination, searchInput}) => {

  const customeRenderButton = gridParams => {
    return <ResubscribeSolution 
    gridParams={gridParams}
    />
  };

  const renderShowLocations = gridParams => {
    return <ShowLocations gridParams={gridParams} />
  }

  const CUSTOM_STYLE = {
    width: "550px"
  };

  const dispatch = useDispatch();

  const state = useSelector(state => state);
  const unsubscribedSolutions = state.subscriptionManagementSlice.unsubscribedSolutions;
  const inActiveBulkSubscriptions =  state.subscriptionManagementSlice.inActiveBulkSubscriptions
  const solutionSubscriptionInfo = state.subscriptionManagementSlice.solutionSubscriptionInfo;
  const fetchingSubscriptions = state.subscriptionManagementSlice.fetchingSubscriptions;
  const planDetails = state.solutionInfoSlice.planDetails;
  const isActivateOnly = state.solutionInfoSlice.solutionInfo.activateOnly;
  const isSolutionInfoSuccess = state.solutionInfoSlice.isSolutionInfoSuccess;
  const appProvider = state.subscriptionManagementSlice.appProvider;
  const token = state && state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;

  const [unsubscribedSolutionsData, setUnsubscribedSolutionsData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [planList, setPlanList] = useState(null);
  const [solutionId, setSolutionId] = useState(null);
  const [solutionName, setSolutionName] = useState(null);
  const [disableProceed, setDisableProceed] = useState(true);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [clickedApp, setClickedApp] = useState('');
  const [clickedAppId, setClickedAppId] = useState('');
  const [isAppNotListed, setIsAppNotListed] = useState(false);

  useEffect(()=>{
    dispatch(clearSolutionInfo());
  }, []);

  const handleResubscribe = (solutionId, token, solutionName, method, activateOnly) => {
    if(method===ACTIVATION || (method === FORTELLIS_ADMIN && activateOnly !== false)){
      sendAmplitudeData(AMPLITUDE_EVENTS.RESUBSCRIBE,{
        [AMPLITUDE_PROPERTIES.APP_NAME] : solutionName,
        [AMPLITUDE_PROPERTIES.APP_ID]: solutionId
      });
     window.open(`${window.location.origin}/dp/${solutionId}`,"_self");
    }
    else{
    dispatch(getSolutionInfo({solutionId, token}));
    setSolutionId(solutionId);
    setSolutionName(solutionName);
    }
  }

  useEffect(()=>{
    if(planDetails?.length){
      const list = [];
      planDetails.map(item => {
        item && ((item.isTheFreeTrial && item.isFreeTrialEnabled) || !(item.isTheFreeTrial)) &&
        list.push(
          <div id={item.id} >
            <div className='plan-info'>
              <div className='plan-name'>
              {item.planName}
              </div>
              {!item.isFreeTrialEnabled && !item.isTheFreeTrial
                ?<div className='plan-details'>
                  {
                    item.billingType === 'TRANSACTIONAL'
                    ? item.transactionalTypeOptions === '$'
                      ? <div className='billing-cost'>
                          {`${item.transactionalTypeOptions} ${item.includedTransactionalFee || '0'} / ${item.includedTransactionalType}`}
                        </div>
                      : <div className='billing-cost'>
                          {`${item.includedTransactionalFee || '0'}${item.transactionalTypeOptions} / ${item.includedTransactionalType}`}
                        </div>
                    : null
                  }
                  {
                    item.billingType === 'ONE TIME'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'}`}
                      </div>
                    : null
                  }
                  {
                    item.billingType === 'RECURRING'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'} / ${item.billingFrequency}`}
                      </div>
                    : null
                  }
                  {
                    item.billingType === 'FREE'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'}`}
                      </div>
                    : null
                  }
                </div>
                :<div className='free-trial-cost'>{'$ 0'}</div>
              }
            </div>
            <div className='plan-details'>
            <div className='billing-type'>
              {!item.isFreeTrialEnabled && !item.isTheFreeTrial
                ? <div>
                    BillingType: {`${item.billingType} `}
                  </div>
                :null
              }
              </div>
              {
                item.includedUnitQuantity && item.includedUnitOfMeasure 
                ? 
                  <div className='billing-cost'>
                    {`Up to ${item.includedUnitQuantity} ${item.includedUnitOfMeasure}`}
                  </div>
                  :null
              }
            </div>
            
          </div>
        );
      });
      setPlanList(list);
      setOpenDialog(true);
      setDisableProceed(true);
    } else {
      setOpenDialog(false);
    }
  },[planDetails]);

  function onOverlayClose(){
    setOpenDialog(false);
  }

  const onSelectPlan = (plan) => {
    setSelectedPlanId(plan.props.id);
    setDisableProceed(false);
  }

  function onOverlayAccept(){
    sendAmplitudeData(AMPLITUDE_EVENTS.RESUBSCRIBE,{
      [AMPLITUDE_PROPERTIES.APP_NAME] : solutionName,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionId,
      [AMPLITUDE_PROPERTIES.SELECTED_PLAN_ID]: selectedPlanId
    });
    setOpenDialog(false);
    window.open(`${window.location.origin}/dp/${solutionId}/${selectedPlanId}`,"_self");
  }

  const goToMarketplace = (orgId, appName, appId) => {
    if (appName) {
      dispatch(getEntityById({ orgId, token }));
      setClickedApp(appName);
      setClickedAppId(appId);
    }
    else{
      setIsAppNotListed(true);
    }
  }
  const column = [
    {
      cellRendererFramework: AppLink,
      field: 'appName',
      headerName: 'App Name',
      width: 390,
      minWidth: 390,
      cellRendererParams: {
        goToMarketplace
      }
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'method',
      headerName: 'Method',
      width: 135,
      minWidth: 135
    },
    {
      cellRendererFramework: renderShowLocations,
      field: 'location',
      headerName: 'Location(s)',
      width: 110,
      minWidth: 110
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'publisher',
      headerName: 'Publisher',
      width: 280,
      minWidth: 280
    },
    {
      cellRendererFramework: customeRenderButton,
      field: 'subscribedOn',
      headerName: 'Subscribed/Activated On',
      width: 287,
      minWidth: 287,
      sortable: true,
      unSortIcon: true,
      comparator: dateComparator
    }
  ];

  useEffect(() => {
    if(appProvider && clickedApp && clickedAppId) {
      let provider = modifyStr(appProvider.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').toLowerCase());
      let appName = modifyStr(clickedApp.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').toLowerCase());
      window.open(`${config.url.marketplace}solutions/${provider}/${appName}?id=${clickedAppId}`);
      setClickedApp('');
      setClickedAppId('');
    }
  }, [appProvider]);


  useEffect(()=>{
    let item = null;
    let unsubscribed = [];
    if(unsubscribedSolutions){
      map(unsubscribedSolutions, (subscription, index) => {
        if(solutionSubscriptionInfo[index]){
          item = {
            appName: solutionSubscriptionInfo[index]?.overview?.name || solutionSubscriptionInfo[index].displayName,
            location: subscription.length,
            publisher: solutionSubscriptionInfo[index]?.overview?.publisherName || solutionSubscriptionInfo[index].orgName,
            subscribedOn: getLatestDate(subscription),
            solutionId: index,
            solutionData: solutionSubscriptionInfo[index],
            subscriptionData: subscription,
            handleResubscribe: handleResubscribe,
            method: solutionSubscriptionInfo[index].activateOnly!==false ? ACTIVATION : SUBSCRIPTION,
            isBulkSubscribed: false,
            rowHeight: 52,
            solutionLogo: solutionSubscriptionInfo[index]?.overview?.solutionLogo,
            orgId: solutionSubscriptionInfo[index]?.orgId,
            appId: solutionSubscriptionInfo[index]?.id
          };
          unsubscribed.push(item);
        }
      });
      setUnsubscribedSolutionsData(unsubscribed);
    }

    if(inActiveBulkSubscriptions){
      map(inActiveBulkSubscriptions, (subscription, index) => {
        if(solutionSubscriptionInfo[index]){
          item = {
            appName: solutionSubscriptionInfo[index]?.overview?.name || solutionSubscriptionInfo[index].displayName,
            location: subscription.length,
            publisher: solutionSubscriptionInfo[index]?.overview?.publisherName || solutionSubscriptionInfo[index].orgName,
            subscribedOn: getLatestDate(subscription),
            solutionId: index,
            solutionData: solutionSubscriptionInfo[index],
            subscriptionData: subscription,
            handleResubscribe: handleResubscribe,
            method: FORTELLIS_ADMIN,
            isBulkSubscribed: true,
            rowHeight: 52,
            solutionLogo: solutionSubscriptionInfo[index]?.overview?.solutionLogo,
            orgId: solutionSubscriptionInfo[index]?.orgId,
            appId: solutionSubscriptionInfo[index]?.id
          };
          unsubscribed.push(item);
        }
      });
      setUnsubscribedSolutionsData(unsubscribed);
    }
  },[unsubscribedSolutions,solutionSubscriptionInfo]);

  useEffect(()=>{
    if(fetchingSubscriptions){
      setUnsubscribedSolutionsData([]);
    }
  },[fetchingSubscriptions]);

  const getRowHeight = params => params.data.rowHeight;

  return (
    <div>
    <div>
      <div className={unsubscribedTableLayout === TABLE_LAYOUT_OPTIONS.NORMAL ? 'unsubscribed_table' : 'unsubscribed_table_no-pagination'}>
        <Table
            columns={column}
            data={unsubscribedSolutionsData?.filter(data => searchInput ? data?.appName?.toLowerCase()?.includes(searchInput.toLowerCase()) || data?.publisher?.toLowerCase()?.includes(searchInput?.toLowerCase()) : true)}
            getRowHeight={getRowHeight}
            hasPagination={checkUnsubscribedTablePagination}
            isSearchable={false}
            isDownloadable={false}
            isPrintable={false}
            resizableHeaders={false}
            showNoRowsOverlay={false}
            showFooter={false}
            hideTableTitle={true}
            hideTableHeader={true}
            tableLayout={unsubscribedTableLayout}
            id="table-with-auto-height-1"
            noRowsFoundMessage='Looks like you could use a few App subscriptions to manage'
            onGridReady={onGridReady}
            sortingOrder={['asc', null, 'desc']}
          />
      </div>
    </div>
      <Overlay
      active={openDialog}
      title={`Choose Your Pricing Plan`} 
      onOverlayClose={onOverlayClose}
      customeStyle={CUSTOM_STYLE}
      onOverlayAccept={onOverlayAccept}
      disableSecondButton={disableProceed}
      >
        <RadioGroup list={planList} onRadioSelection={onSelectPlan} />
      </Overlay>

      <Dialog
       
       isOpen={isAppNotListed}
       dataTestId="restricted-subscription-management-dialog"
       hideCloseButton={false}
       onClose={() => setIsAppNotListed(false)}
       id="overlay-id"
       closeLabel="Close"
       title = 'App has been removed from Marketplace'
      >
       This app is no longer available in Marketplace. Contact the Publisher for more details.
      </Dialog>
    </div>
  );
}

export default AuthComponent(UnsubscribedTable);
